<script>
import $ from 'jquery';
import axios from "axios";

export default {
  name: 'TasksMadeAndExpensesModal',
  inject: ['eventHub'],
  created() {
    this.eventHub.$on('tasks-made-expenses-modal', (customerService) => {
      this.customerService = customerService;
      this.loadInit();
      $('#tasks-made-expenses').modal('show');
    })
  },
  data () {
    return {
      customerService: false,
      incurredExpenses: false,
      tasksMade: false,
      taskTypes: false,
      taskTypeId: false,
      errors: {},
    }
  },
  methods: {
    loadInit () {
      this.loadTasksMade();
      this.loadListIncurredExpense();
      this.loadTaskTypes();
    },
    loadTasksMade () {
      axios
        .get(`/api/customer-service/${this.customerService.id}/tasks-made`)
        .then(({ data }) => this.tasksMade = data.data)
    },
    loadListIncurredExpense () {
      axios
        .get(`/api/incurred-expense/ticket/${this.customerService.id}`)
        .then(({ data }) => this.incurredExpenses = data.data)
    },
    loadTaskTypes () {
      axios
        .get('/api/task_types')
        .then(({ data }) => this.taskTypes = data.data)
    },
    updateTaskType (taskMade) {
      axios
        .patch(`/api/tasks-made/${taskMade.id}/task-type`, {
          task_type_id: taskMade.task_type.data.id
        })
        .then(() => {
          this.$toast.success("Registro atualizado com sucesso!");
          this.loadTasksMade()
        })
        .catch((err) => {
          this.errors = err.response.data.errors;
          this.requestFail();
        });
    },
    requestFail () {
      let message = '';
      for (let i in this.errors) {
        message = `${this.errors[i]} <br /> ${message}`
      }
      this.$swal({
        title: 'Ops...',
        text: message,
        icon: 'error',
        html: message,
      })
    },
    formatDateBrToView (originalDate) {
      const data = new Date(originalDate);
      let timezoneOffset = -180;
      data.setMinutes(data.getMinutes() - timezoneOffset);
      return data.toLocaleDateString("pt-BR");
    },
    secondsToDate(seconds) {
      if (isNaN(seconds)) {
        return '00:00:00'
      }
      let hours = Math.floor(seconds / 3600)
      seconds %= 3600
      let minutes = Math.floor(seconds / 60)
      seconds = seconds % 60

      return String(hours).padStart(2, '0') + ':' + String(minutes).padStart(2, '0') + ':' + String(Math.floor(seconds)).padStart(2, '0')
    },
  }
}
</script>

<template>
  <div
    class="modal fade"
    id="tasks-made-expenses"
    tabindex="-1"
    aria-labelledby="tasks-made-expenses"
    aria-hidden="true"
    role="dialog"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
  >
    <div class="modal-dialog modal-xl modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title text-center">
            Consultor: {{customerService.user_name}} -
            Ticket: {{customerService.id}} - {{customerService.customer_name}}
          </h4>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <section class="d-flex flex-column mt-4">
            <div class="card card-body">
            <h5 class="text-center">Atividades</h5>
              <table class="table table-striped tasks-table small">
                <thead>
                <tr>
                  <th>Data</th>
                  <th>Inicio</th>
                  <th>Fim</th>
                  <th>Duração</th>
                  <th>Atividade</th>
                  <th>Tipo de Trabalho</th>
                  <th>Valor Hora</th>
                  <th>Valor Total</th>
                  <th>Observação</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="taskMade in tasksMade" :key="taskMade.id">
                  <td>{{formatDateBrToView(taskMade.made_at)}}</td>
                  <td>{{taskMade.started_at}}</td>
                  <td>{{taskMade.finished_at}}</td>
                  <td>{{secondsToDate(taskMade.time_spent)}}</td>
                  <td>{{taskMade.task.data.name}}</td>
                  <td>
                    <v-select
                      :disabled="taskMade.invoiced"
                      :reduce="item => item.id"
                      placeholder="Tipo de Trabalho"
                      label="name"
                      v-model="taskMade.task_type.data.id"
                      :options="taskTypes"
                      v-if="taskTypes"
                      @input="updateTaskType(taskMade)"
                      />
                  </td>
                  <td class="tasks-td-small"><money class="hide-input" v-model="taskMade.task_type.data.amount" disable/></td>
                  <td class="tasks-td-small"><money class="hide-input" v-model="taskMade.amount" disable/></td>
                  <td>{{taskMade.note}}</td>
                </tr>
                </tbody>
              </table>
            </div>

            <div class="card card-body mt-4">
              <h5 class="text-center">Despesas</h5>
              <table class="table table-striped tasks-table small">
                <thead>
                <tr>
                  <th>Data</th>
                  <th>Tipo de despesa</th>
                  <th>Valor</th>
                  <th>Observação</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="expense in incurredExpenses" :key="expense.id">
                  <td>{{formatDateBrToView(expense.date)}}</td>
                  <td>{{expense.expense_name}}</td>
                  <td class="tasks-td-small"><money class="hide-input" v-model="expense.amount" disable/></td>
                  <td>{{expense.note}}</td>

                </tr>
                </tbody>
              </table>
            </div>
          </section>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="sass">
.tasks-table
  font-size: small

  td
    button
      margin-right: 3px

  tr
    max-height: 10px

  input
    font-size: small

.tasks-td-small
  min-width: 80px
  max-width: 110px
  white-space: nowrap
</style>
